import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=22e41d46&scoped=true"
import script from "./DashboardOverview.vue?vue&type=script&lang=js"
export * from "./DashboardOverview.vue?vue&type=script&lang=js"
import style0 from "./DashboardOverview.vue?vue&type=style&index=0&id=22e41d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e41d46",
  null
  
)

export default component.exports